<!--服务详情-->
<template>
  <div class="service-detail-container">
    <header-index/>
    <div class="service-detail-content">
      <div class="service-breadcrumb">
        <span>您当前位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/cloudPlatform/platform?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">服务平台
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/loan/index' }" v-if="backIndex==2">企业服务</el-breadcrumb-item>
          <el-breadcrumb-item>职位详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="service-info">
        <div class="service-detail-menu1">
          <div class="service-info-left">
            <p class="service-title">{{serviceData.name}}</p>
            <div class="service-label-list">
              <div>
                <p class="service-red-p">{{ number_format((parseFloat(serviceData.maximumAmount)*10000),2,'.',',')}}</p>
                <p class="service-normal-p">最高额度</p>
              </div>
              <div>
                <p class="service-red-p">{{ serviceData.apr}}</p>
                <p class="service-normal-p">年利率</p>
              </div>
              <div>
                <p class="service-red-p">{{ serviceData.repaymentPeriod}}<span class="unit">个月</span></p>
                <p class="service-normal-p">贷款期限</p>
              </div>
            </div>
          </div>
          <div class="service-info-right">
            <el-button class="el-button-danger" type="danger" @click="applyLoan">立即申请</el-button>
          </div>
        </div>
        <div class="service-content">
          <el-row :gutter="16">
            <el-col :span="17">
              <div class="service-content-left">
                <p class="service-content-title">详情</p>
                <div class="el-service-info" v-for="swiperArr of serviceData.swiperArr">
                  <el-image :src="swiperArr"/>
                </div>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="service-content-right">

              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <el-dialog title="申请贷款" :visible.sync="dialogVisible" class="dialog" width="35%">
      <el-form :model="loanForm" :rules="rules" ref="loanForm" class="loanForm" label-position="right" label-width="85px" :hide-required-asterisk="true">
        <el-form-item label="贷款金额：" prop="price">
          <el-input v-model="loanForm.price"><i class="price-icon" slot="suffix">万元</i></el-input>
        </el-form-item>
        <el-form-item label="贷款用途：" prop="purpose">
          <el-input v-model="loanForm.purpose"/>
        </el-form-item>
        <el-form-item label="联系人：" prop="contacts">
          <el-input v-model="loanForm.contacts"/>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input v-model="loanForm.phone"/>
        </el-form-item>
        <el-form-item label="联系地址：" prop="address">
          <el-input v-model="loanForm.address"/>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button @click="dialogVisible=false">取消</el-button>
          <el-button type="danger" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {yqzdGoodsInfo,yqzdApplyLoans} from '@/api/loanApi';
import {isMobile, isMoney} from "@/common/tools";
export default {
  name: "serviceDetails",
  components: {headerIndex, home_footer, Hang},
  data() {
      const checkMoney = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('贷款金额不能为空'));
        } else if (!isMoney(value)) {
          callback(new Error('请输入合法的金额数字，最多两位小数'));
        } else {
          callback();
        }
      }
    const checkNull = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('贷款用途不能为空'));
      } else {
        if (value.length<5 || value.length>300){
          callback(new Error('请填写实际的真实贷款用途，字数限制在5-300之间'));
        }else{
          callback();
        }
      }
    }
    const checkPhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入联系电话'));
      } else if (!isMobile(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    }

    return {
      serviceData: {},
      min_height: document.documentElement.clientHeight - 315,
      cid:0,
      pName:'',
      id:0,
      childNode:{},
      backIndex:0,
      dialogVisible:false,
      loanForm:{
        price:null,
        purpose:'',
        contacts:'',
        phone:'',
        address:'',
      },
      rules:{
        price:[
          {validator: checkMoney, trigger: 'blur'}
        ],
        purpose:[
          {validator: checkNull, trigger: 'blur'}
        ],
        contacts:[
          { required: true, message: '请填写贷款联系人', trigger: 'blur' }
        ],
        phone: [
          {validator: checkPhone, trigger: 'blur'}
        ],
        address:[
          { required: true, message: '请填写联系地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    /*银企服务详情*/
    goodsDetails(){
      yqzdGoodsInfo({
        id: this.id,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res=>{
        if (res.code == 200) {
          this.serviceData=res.content;
        }
      })
    },
    /*金额转化*/
    number_format(number, decimals, dec_point, thousands_sep) {
      decimals = 2; //这里默认设置保留两位小数，也可以注释这句采用传入的参数
      /*
       * 参数说明：
       * number：要格式化的数字
       * decimals：保留几位小数
       * dec_point：小数点符号
       * thousands_sep：千分位符号
       * */
      number = (number + '').replace(/[^0-9+-Ee.]/g, '');
      let n = !isFinite(+number) ? 0 : +number;
      let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
      let sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep;
      let dec = (typeof dec_point === 'undefined') ? '.' : dec_point;
      let s = n.toString().split('.');
      let re = /(-?\d+)(\d{3})/;
      while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
      }
      if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
      } else {
        s[1] = s[1].substring(0, prec); //小数点位数超出长度时截取前面的位数
      }
      return s.join(dec);
    },
    /*申请贷款*/
    applyLoan(){
      this.dialogVisible=true;
    },
    /*提交*/
    onSubmit(){
      this.$refs.loanForm.validate((valid) => {
        if (valid) {
          yqzdApplyLoans({
            address: this.loanForm.address,
            contact: this.loanForm.contacts,
            fullAmount: this.loanForm.price===this.serviceData.maximumAmount ? 1 : 0,
            id: this.id,
            loanPurpose: this.loanForm.purpose,
            mobile: this.loanForm.phone,
            money: this.loanForm.price,
            uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
          }).then(res=>{
            if (res.code==200){
              this.$message.success(res.msg);
              this.dialogVisible=false;
            }
          })
        }else{
          return false;
        }
      })
    }
  },
  mounted() {
    this.goodsDetails();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    this.id=this.$route.query.id;
    this.backIndex=this.$route.query.backIndex;
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
.service-detail-container >>> .service-detail-content .service-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #5D5D5D;
}

.service-detail-container >>> .service-detail-content .service-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.service-detail-container >>> .service-detail-content .service-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.service-detail-container >>> .service-detail-content .service-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.service-detail-container >>> .service-detail-content .service-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
.service-detail-container >>> .service-detail-content .service-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.service-detail-container >>> .service-detail-content .service-breadcrumb .el-breadcrumb__inner a,
.service-detail-container >>> .service-detail-content .service-breadcrumb .el-breadcrumb__inner.is-link{
  font-weight: 100;
  color: #333333;
}
.service-detail-container >>> .service-detail-content .service-info .service-detail-menu1 .service-info-right .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 20px 65px;
}

.service-detail-container >>> .service-detail-content .service-info .service-detail-menu1 .service-info-right .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
/* 设置dialog弹出框的样式 */
.service-detail-container >>> .dialog .el-dialog__header {
  border-bottom: 1px solid #DDDDDD;
  padding: 10px 20px;
  background: #ffffff;
  border-radius: 10px 10px 0px 0px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 弹出框标题字体 */
.service-detail-container >>> .dialog .el-dialog__title {
  font-size: 16px;
  font-family: 'SourceHanSansCN';
  color: #222222;
}
.service-detail-container >>> .dialog .el-dialog__headerbtn {
  position: relative;
  padding: 0px;
  background: center;
  border: none;
  outline: 0;
  cursor: pointer;
  top: auto;
  right: auto;
  font-size: 16px;
}
.service-detail-container >>> .dialog .el-dialog__body {
  padding: 0px 20px 20px;
  color: #606266;
  font-size: 14px;
}

.service-detail-container >>> .dialog .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
}

.service-detail-container >>> .dialog .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
</style>
<style scoped lang="scss">
.service-detail-container{
  background: #E7E9F5;
  .service-detail-content{
    padding: 10px 18%;
    .service-breadcrumb{
      display: flex;
      justify-content: left;
      font-size: 14px;
      font-weight: 100;
      color: #333333;
      font-family: "SourceHanSansCN";
    }
    .service-detail-menu1{
      background: #ffffff;
      padding: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .service-info-left{
        width: 25vw;
        .service-title{
          margin-block-end: 30px;
          margin-block-start: 0px;
          font-size: 36px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
        .service-label-list{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .service-red-p{
            color: #333333;
            font-size: 24px;
            font-family: 'SourceHanSansCN';
            margin-block-end: 0px;
            margin-block-start: 0px;
            .unit{
              color: #666666;
              font-size: 18px;
            }
          }
          .service-normal-p{
            margin-block-end: 0px;
            margin-block-start: 0px;
            font-size: 16px;
            color: #999999;
            font-family: 'SourceHanSansCN';
          }
        }
      }
    }
    .service-content{
      margin-top: 20px;
      .service-content-left{
        padding: 20px 30px;
        background: #ffffff;
        box-shadow: 0px 8px 18px 0px rgba(231,233,245,0.6);
        .service-content-title{
          color: #333333;
          font-family: SourceHanSansCN;
          font-size: 16px;
          margin-block-end: 20px;
          margin-block-start: 0px;
        }
        .el-service-info{
          .el-image {
            position: relative;
            display: inline-block;
            overflow: hidden;
            width: 100%;
          }
        }
      }
      .service-content-right{
        padding: 20px;
      }
    }
  }
  .dialog{
    .loanForm{
      margin: 20px 0px;
      .price-icon {
        font-style: normal;
        font-size: 14px;
        color: #333333;
        padding-right: 10px;
      }
    }
  }
}
</style>